import { Flex, Stack, useMantineTheme } from '@mantine/core';
import type { JSX } from 'react';
import React from 'react';

import { Text } from '@feathr/components';

import type { ISetupStepConfig } from '../MetaGetStarted.hooks';

import * as styles from './MetaSetupSteps.css';

interface IProps {
  steps: ISetupStepConfig[];
}

function MetaSetupSteps({ steps }: Readonly<IProps>): JSX.Element {
  const theme = useMantineTheme();

  return (
    <Stack gap={theme.spacing['4']} w={'100%'}>
      {steps.map(({ stepNumber, title, description }) => (
        <Flex
          align={'flex-start'}
          className={styles.step}
          gap={theme.spacing['3']}
          key={stepNumber}
        >
          <Flex align={'center'} className={styles.stepNumber} justify={'center'}>
            {stepNumber}
          </Flex>
          <Stack gap={theme.spacing['1']}>
            <Text.DefaultHeadingMedium>{title}</Text.DefaultHeadingMedium>
            <Text.DefaultRegular>{description}</Text.DefaultRegular>
          </Stack>
        </Flex>
      ))}
    </Stack>
  );
}

export default MetaSetupSteps;
